import { Container } from '@chakra-ui/react'
import { Content } from '@twlvxtwlv/ui/src/components/shared/content'
import { Page } from '@twlvxtwlv/ui/src/components/shared/page'
import { Section } from '@twlvxtwlv/ui/src/components/shared/section'
import { promises as fs } from 'fs'
import type { GetStaticProps, GetStaticPropsContext, InferGetStaticPropsType } from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import Head from 'next/head'
import path from 'path'

interface TermsOfSalePageProps {
  content: string
}

export default function TermsOfSalePage({
  content,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  const { t } = useTranslation(['common'])

  return (
    <Page bgColor="white">
      <Head>
        <title>{t('meta-title-legal-top')}</title>
      </Head>
      <Section>
        <Container maxW="840px">
          <Content content={content} />
        </Container>
      </Section>
    </Page>
  )
}

export const getStaticProps: GetStaticProps<TermsOfSalePageProps> = async ({
  locale = 'de',
}: GetStaticPropsContext) => {
  const filePath = path.join(process.cwd(), 'public/markdown/terms_of_sale.md')
  const content = await fs.readFile(filePath, 'utf8')
  return {
    props: {
      content,
      ...(await serverSideTranslations(locale, ['common', 'navigation', 'footer'])),
    },
  }
}
